const nl = {
  common: {
    loading: 'Bezig met laden...',
    error: 'Fout',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    moveUp: 'Omhoog',
    moveDown: 'Omlaag',
    close: 'Sluiten',
    confirm: 'Bevestigen',
    search: 'Zoeken',
    filter: 'Filteren',
    export: 'Exporteren',
    yes: 'Ja',
    no: 'Nee',
    back: 'Terug',
    next: 'Volgende',
    submit: 'Verzenden',
    darkMode: 'Donkere modus',
    lightMode: 'Lichte modus',
    languageMenuTitle: 'Taal wijzigen',
    pagerShow: 'Tonen',
    pagerPerPage: 'per pagina',
    pagerOf: 'van',
    viewCards: 'Kaartweergave',
    viewList: 'Lijstweergave',
    collapse: 'Inklappen',
    expand: 'Uitklappen',
    previousPage: 'Vorige pagina',
    nextPage: 'Volgende pagina',
    retry: 'Opnieuw proberen',
    errorBoundaryTitle: 'Er is iets misgegaan',
    errorGeneric: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
    expandModal: 'Uitvouwen in modaal venster',
    resetToGlobal: 'Terugzetten naar globaal',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Start',
    growth: 'Groei',
    admin: 'Beheer',
    executive: 'Directie',
    analytics: 'Analyse',
    switchDemoProfile: 'Demoprofiel wisselen',
    mobileNav: 'Hoofdnavigatie',
  },
  roles: {
    employee: 'Medewerker',
    adminOU: 'OE-beheerder',
    adminGlobal: 'Globale beheerder',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Openstaande enquêtes',
    pending: 'In behandeling',
    completed: 'Voltooid',
    expired: 'Verlopen',
    submit: 'Beoordeling versturen',
    skip: 'Overslaan',
    noObs: 'Geen observatie',
    meeting: 'Vergadering',
    duration: 'Duur',
    participants: 'Deelnemers',
    simulateMeeting: 'Einde vergadering simuleren',
    thankYou: 'Bedankt voor je beoordeling!',
    evaluating: 'Beoordelen van',
    of: 'van',
    question: 'Vraag',
    selectResponse: 'Selecteer een antwoord',
    nps: {
      question: 'Hoe waarschijnlijk is het dat je aanbeveelt om met deze persoon samen te werken?',
      detractor: 'Criticaster',
      passive: 'Passief',
      promoter: 'Promotor',
    },
    evaluateNow: 'Nu beoordelen',
    postpone: 'Later',
    expires: 'Verloopt',
    noSurveysPending: 'Geen openstaande enquêtes! Goed gedaan.',
    weekCompleted: 'wk.',
    likert: {
      always: 'Altijd',
      usually: 'Meestal',
      sometimes: 'Soms',
      rarely: 'Zelden',
      notObservable: 'Niet waarneembaar',
    },
    questions: {
      listenedActivelyText: 'Heeft deze persoon actief geluisterd en oprechte interesse getoond?',
      sharedKnowledgeText: 'Heeft hij of zij relevante kennis of ervaringen gedeeld tijdens de sessie?',
    },
    completeSubtitle: 'Jouw feedback helpt de teamcultuur te versterken.',
    backToHome: 'Terug naar start',
    greetingMorning: 'Goedemorgen',
    greetingAfternoon: 'Goedemiddag',
    greetingEvening: 'Goedenavond',
    pendingCountPre: 'Je hebt',
    pendingCountSingular: 'openstaande enquête',
    pendingCountPlural: 'openstaande enquêtes',
    allDoneTitle: 'Helemaal bij!',
    allDoneSubtitle: 'Je hebt geen openstaande enquêtes. Ze verschijnen hier na je volgende vergadering.',
    omit: 'Overslaan',
    omitSurvey: 'Enquête overslaan',
    submitSuccess: 'Antwoorden verzonden',
    submitError: 'Fout bij verzenden — probeer het opnieuw',
    omitSuccess: 'Enquête overgeslagen',
    omitError: 'Fout bij overslaan — probeer het opnieuw',
    kpi: {
      answered: 'Beantwoord',
      omitted: 'Overgeslagen',
      streak: 'Reeks',
      participation: 'Deelname',
    },
    growth: {
      title: 'Jouw groei wacht op je',
      message: 'Bekijk je resultaten, trends en ontwikkelpunten in je groeidashboard.',
      cta: 'Bekijk mijn groei',
    },
    tips: {
      title: 'Tips voor jou',
      based: 'Gebaseerd op je gemiddelde score',
      empty: 'Voltooi meer enquêtes om persoonlijke tips te zien',
      reconocer: 'Om te erkennen',
      crecer: 'Om te groeien',
      tipOfDay: 'Tip van de dag',
    },
  },
  safe: {
    title: 'Mijn Groei',
    subtitle: 'Jouw culturele ontwikkeling bij Sigma',
    sectionName: 'Mijn feedback',
    surveysAnswered: 'Beantwoorde enquêtes',
    score: 'Jouw Score',
    evolution: 'Jouw ontwikkeling',
    evolutionSub: 'Jouw persoonlijke reis — alleen jij, zonder vergelijkingen',
    radarTitle: 'Jouw profiel per Fundament',
    radarSub: 'Jij vandaag vs jij 3 maanden geleden',
    fundamentals: 'Fundamenten',
    fundamentalsChart: 'Jouw feedback per Fundament',
    fundamentalsChartSub: 'Waar je op elk gebied staat — klik op een balk voor details',
    behaviors: 'Gedragingen',
    kudos: 'Kudos',
    kudosTitle: 'Om te erkennen — wat je het meest inbrengt',
    kudosSub: "Wat je collega's deze maand het meest bij je opmerken",
    actions: 'Actieplan',
    omissions: 'Overslagen',
    period: 'Periode',
    received: 'Ontvangen',
    sent: 'Verzonden',
    areaAverage: 'Gemiddelde van het gebied',
    today: 'Vandaag (jan 2026)',
    threeMonthsAgo: '3 maanden geleden (okt 2025)',
    detail: 'Detail',
    profileTitle: 'Jouw culturele profiel in woorden',
    profileSub: 'Gedragingen, geen cijfers',
    basedOn: 'Gebaseerd op {{count}} anonieme feedbacks',
    level0: 'Beginnend',
    level1: 'In ontwikkeling',
    level2: 'Consistent',
    level3: 'Rolmodel',
    level0desc: 'Wacht tot anderen problemen oplossen of obstakels wegnemen.',
    level1desc: 'Probeert obstakels aan te pakken, maar geeft snel op of escaleert te vroeg.',
    level2desc: 'Neemt het initiatief om obstakels weg te nemen en oplossingen te vinden om vooruitgang te boeken.',
    level3desc: 'Inspireert anderen om initiatief te nemen en creëert een omgeving waarin het wegnemen van blokkades een gedeelde verantwoordelijkheid is.',
    levelAbbr0: 'Start',
    levelAbbr1: 'In ontw.',
    levelAbbr2: 'Consist.',
    levelAbbr3: 'Rolmodel',
    todayLabel: 'Vandaag',
    pointsInMonths: 'punten in {{n}} maanden',
    monthsWithFeedback: 'maanden met feedback',
    thisMonth: 'deze maand',
    headingToLevel: 'Op weg naar {{level}}',
    maxLevel: 'Maximaal niveau!',
    narrativeStrength: 'Wat je het meest bijdraagt en erkenning verdient is <strong>{{fund}}</strong> — je bevindt je op niveau <strong>{{level}}</strong>.',
    narrativeConsistency: 'Je toont ook consistentie in {{others}}.',
    narrativeProgress: 'De afgelopen 3 maanden ben je vooruitgegaan — je profiel laat groei zien.',
    narrativeStable: 'Je profiel is de afgelopen 3 maanden stabiel gebleven — dat wijst op consistentie.',
    narrativeVariation: 'Je profiel is de afgelopen maanden een beetje gevarieerd. Variaties zijn normaal en bepalen niet wie je bent.',
    narrativeNextLevel: 'Je volgende groeiniveau ligt in <strong>{{fund}}</strong>. De volgende stap is om niveau {{level}} te bereiken — hieronder stellen we een concrete actie voor.',
    act01: 'Erkenning — hoe anderen je zien',
    act02: 'Voortgang — hoe je je hebt ontwikkeld',
    act03: 'Richting — jouw volgende stap',
    reinforces: 'VERSTERKT',
    tryToday: 'Ik probeer dit vandaag',
    committed: 'Ik zet me hier vandaag voor in!',
    defaultChallenge: 'Oefen vandaag een fundament',
    defaultChallengeDesc: 'Kies een micro-actie en breng die in je volgende vergadering in de praktijk.',
    clickDetail: 'Klik voor detail',
    nextLevel: 'VOLGEND NIVEAU',
    growthTitle: 'OM VERDER TE GROEIEN',
    growthSub: 'Aanbevelingen op basis van jouw feedback',
    feedbacks: 'feedbacks',
    peers: "collega's",
    givenTitle: 'Mijn deelname bij het geven van feedback',
    givenSub: 'Feedback die je deze maand hebt gedeeld',
    footerPrivacy: 'Alle feedback is anoniem. Niemand kan zien wie het jou heeft gegeven. Dit overzicht is alleen van jou.',
    footerHeart: 'Onthoud: feedback is een geschenk. Deze gegevens weerspiegelen momenten tijdens vergaderingen, niet wie je bent.',
    personSingular: 'persoon',
    personsPlural: 'personen',
    trend: {
      up: 'Je profiel laat groei zien',
      down: 'Kleine variatie — dat is normaal',
      stable: 'Stabiel profiel — dat is consistentie',
    },
    empty: {
      title: 'Leer de Fundamentals kennen',
      desc: 'Je hebt nog niet genoeg feedback om je dashboard te tonen. Verken ondertussen de gedragingen die we meten.',
      hint: 'Je hebt minstens 3 evaluaties nodig om je persoonlijke dashboard te activeren. Doe mee aan de enquêtes na vergaderingen om feedback te ontvangen.',
    },
    popup: {
      peersOpined: "collega's beoordeelden",
      subbehaviors: 'Subgedragingen',
      monthlyHistory: 'Maandelijkse ontwikkeling',
      distribution: 'Feedbackverdeling',
      behaviorScale: 'Gedragsschaal',
      you: 'Jij',
    },
  },
  admin: {
    title: 'Beheer',
    panelTitle: 'Beheerpaneel',
    roleAdminCentral: 'Centrale beheerder',
    roleAdminOU: 'OE-beheerder',
    roleEmployee: 'Medewerker',
    greetingMorning: 'Goedemorgen',
    greetingAfternoon: 'Goedemiddag',
    greetingEvening: 'Goedenavond',
    surveys: 'Enquêtes',
    templates: 'Sjablonen',
    analyticsTab: 'Analyse',
    rulesTab: 'Bedrijfsregels',
    users: 'Gebruikers',
    notifications: 'Meldingen',
    surveysTitle: 'Enquêtebeheer',
    searchSurvey: 'Enquête zoeken...',
    trash: 'Prullenbak',
    newSurvey: 'Nieuwe enquête',
    fundamentalsTab: 'Algemeen',
    customTab: 'Aangepast',
    colName: 'Naam',
    colTitle: 'Titel',
    colDescription: 'Beschrijving',
    colQuestions: 'Vragen',
    colStatus: 'Status',
    colAudience: 'Doelgroep',
    colFrequency: 'Frequentie',
    colFeedback: 'Feedback',
    colPeriod: 'Periode',
    colActions: 'Acties',
    colCreatedBy: 'Aangemaakt door',
    colEmail: 'E-mail',
    colOU: 'OE',
    colUses: 'keer gebruikt',
    statusActive: 'Actief',
    statusPaused: 'Gepauzeerd',
    statusInactive: 'Inactief',
    statusPending: 'In behandeling',
    anonymous: 'Anoniem',
    duplicate: 'Dupliceren',
    exportExcelTip: 'Excel exporteren',
    templatesTitle: 'Enquêtesjablonen',
    tipsTab: 'Tips',
    actionsTab: 'Acties',
    catalogTab: 'Catalogi',
    createTemplate: 'Sjabloon maken',
    typeFundamental: 'Fundament',
    typeCustom: 'Aangepast',
    placeholderTips: 'Tips — Adviesmodule voor medewerkers',
    placeholderActions: 'Acties — Actieplannen na de enquête',
    placeholderCatalog: 'Fundamentencatalogus — Bibliotheek van beoordeelbaar gedrag',
    tplSearchPlaceholder: 'Sjabloon zoeken…',
    tplFilterAll: 'Alle types',
    tplNoResults: 'Geen sjablonen voldoen aan dat criterium',
    tipsTitle: 'Feedbacktips',
    tipsSearchPlaceholder: 'Tip zoeken…',
    tipsAllFundamentals: 'Alle Fundamenten',
    tipsAllTypes: 'Alle types',
    tipTypeReconocer: 'Om te erkennen',
    tipTypeCrecer: 'Om te groeien',
    tipsNoResults: 'Geen tips voldoen aan dat criterium',
    surveysNoResults: 'Geen enquêtes voldoen aan dat criterium',
    surveysError: 'Fout bij het laden van enquêtes. Probeer het later opnieuw.',
    createTip: 'Tip maken',
    actionsTitle: 'Groeiacties',
    actionsSearchPlaceholder: 'Actie zoeken…',
    actionsNoResults: 'Geen acties voldoen aan dat criterium',
    createAction: 'Actie maken',
    catalogTitle: 'Fundamentencatalogus',
    catalogFundamentals: 'Fundamenten',
    catalogBehaviors: 'Gedragingen',
    catalogAddFundamental: 'Fundament toevoegen',
    catalogAddBehavior: 'Daily Habit toevoegen',
    catalogSearchFundamental: 'Fundament zoeken…',
    catalogSearchBehavior: 'Daily habit zoeken…',
    catalogNoBehaviors: 'Geen daily habits voor dit fundament',
    catalogSelectFundamental: 'Selecteer een Fundament uit de lijst',
    ousTab: "OE's",
    ousTitle: 'Organisatie-eenheden',
    ousSubtitle: "Beheer root-OE's voor deze tenant",
    ousSearchPlaceholder: 'OE zoeken…',
    ousNoResults: "Geen OE's voldoen aan dat criterium",
    createOU: 'OE maken',
    editOU: 'OE bewerken',
    deleteOU: 'OE verwijderen',
    deleteOUConfirm: 'OE "{{name}}" verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    ouDescription: 'Beschrijving',
    ouAdminUser: 'OE-beheerder (AAD-gebruikers-ID)',
    ouType: 'Type',
    ouGdpr: 'AVG',
    ouAzureGroupId: 'Azure AD-groeps-ID',
    ouAzureGroupIdHint: 'Koppel deze OE aan de bijbehorende Azure AD-groep voor de hiërarchische boomstructuur. Laat leeg als deze nog niet is voorzien.',
    ouAzureGroupIdSelectPlaceholder: '— Selecteer een Azure AD-hoofdgroep —',
    ouAzureGroupIdLoading: 'Azure AD-groepen worden geladen…',
    ouAzureGroupIdRootsError: 'De lijst met Azure AD-groepen kon niet worden geladen. Je kunt de ID handmatig invoeren.',
    ouAzureGroupIdCurrentUnknown: 'Momenteel gekoppelde groep (niet in de lijst)',
    ouAzureGroupIdManualToggle: 'ID handmatig invoeren',
    ouAzureGroupIdListToggle: 'Kiezen uit de lijst',
    ouActivate: 'OE activeren',
    ouDeactivate: 'OE deactiveren',
    ouExpand: 'Uitvouwen',
    ouCollapse: 'Invouwen',
    ouSelectPlaceholder: 'OU selecteren…',
    ouErrorName: 'OE-naam is verplicht',
    ouTimezone: 'Tijdzone',
    ouTimezoneSelect: 'Selecteer tijdzone',
    ouErrorTimezone: 'Tijdzone is verplicht',
    colFundamental: 'Fundament',
    colCondition: 'Voorwaarde',
    placeholderAnalytics: 'Uniform analysedashboard — Zie de directieweergave voor volledige details',
    activeUsersLabel: 'Actieve medewerkers',
    avgCulturalScore: 'Gemiddelde culturele score',
    participationRateLabel: 'Deelnamepercentage',
    omissionRateLabel: 'Overslagpercentage',
    thisMonth: 'deze maand',
    rulesTitle: 'Bedrijfsregels',
    restoreDefaults: 'Standaardwaarden herstellen',
    restoreDefaultsTitle: 'Standaardconfiguratie herstellen',
    restoreDefaultsDesc: 'Alle waarden van de bedrijfsregels worden teruggezet naar hun oorspronkelijke configuratie. Deze actie kan niet ongedaan worden gemaakt.',
    restoreDefaultsConfirm: 'Ja, herstellen',
    rn001Title: 'Vergadercriteria',
    rn001Subtitle: 'Bepaalt de vergaderduur die een enquête activeert',
    rn002Title: 'Uitsluitingsregels',
    rn002Subtitle: "Scenario's waarin GEEN enquêtes worden geactiveerd",
    rn004Title: 'Gebruikerslimieten',
    rn004Subtitle: 'Regelt het aantal enquêtes dat elke persoon ontvangt',
    rn005Title: 'Dagelijkse enquêtelimiet',
    rn005Subtitle: 'Maximaal aantal enquêtes dat een gebruiker per dag kan ontvangen',
    fieldMinSessionDuration: 'Minimale sessieduur',
    fieldMaxSessionDuration: 'Maximale sessieduur',
    fieldMinParticipants: 'Minimum aantal deelnemers',
    fieldMaxParticipants: 'Maximum aantal deelnemers',
    fieldExclRecurring: 'Terugkerende vergaderingen uitsluiten',
    fieldExclRecurringSub: 'Niet toepassen op wekelijkse vergaderingen, dailies, enz.',
    fieldExclWorkHours: 'Uitsluiten buiten werktijden',
    fieldExclWorkHoursSub: 'Alleen toepassen binnen de per OE geconfigureerde uren',
    fieldMaxSurveysWeek: 'Maximum aantal enquêtes per week',
    fieldMaxParticipantsPerSurvey: 'Maximum aantal te beoordelen deelnemers per enquête',
    fieldMinInterval: 'Minimuminterval tussen enquêtes',
    fieldMaxSurveysDay: 'Maximum aantal enquêtes per dag per gebruiker',
    rn005Info: 'Als een gebruiker al het maximale aantal enquêtes voor die dag heeft ontvangen, worden de volgende uitgesteld naar de eerstvolgende werkdag, met inachtneming van de geconfigureerde prioriteitsvolgorde.',
    suffixMinutes: 'minuten',
    suffixUsers: 'gebruikers',
    suffixSurveysWeek: 'enquêtes/week',
    suffixPersons: 'personen',
    suffixHours: 'uur',
    suffixSurveysDay: 'enquêtes / dag',
    customizableByOU: 'Aanpasbaar per OE',
    cancelChanges: 'Wijzigingen annuleren',
    saveConfig: 'Configuratie opslaan',
    rulesConfig: 'Configuratie',
    rulesStatus: 'Status',
    rulesCustom: 'Aangepast',
    rulesSave: 'Opslaan',
    rulesCancel: 'Annuleren',
    rulesSchedule: 'Planning',
    rulesInheritsGlobal: '↑ Erft globaal',
    rulesInherited: 'Overgenomen',
    rulesGlobal: 'Globaal',
    rulesPersonalize: 'Aanpassen',
    tplCatAll: 'Alle',
    tplCatGeneral: 'Algemeen',
    tplCatCustom: 'Aangepast',
    usersTitle: 'Gebruikersbeheer',
    searchUser: 'Gebruiker zoeken...',
    newUser: 'Nieuwe gebruiker',
    notificationsTitle: 'Meldingsinstellingen',
    notifOmitirTitle: 'Melding bij overslaan',
    notifyAfter: 'Melden na',
    consecutiveOmissions: 'opeenvolgende overslagen',
    notifyTo: 'Melden aan:',
    notifyUser: 'Gebruiker',
    notifyDirectManager: 'Direct leidinggevende',
    notifyAdminOU: 'OE-beheerder',
    messageForUser: 'Bericht voor de gebruiker:',
    availableVarsOmitir: 'Beschikbare variabelen: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Overslagen Europa (BU)',
    manualOnlyGDPR: 'Alleen handmatig — AVG',
    gdprWarning: 'Vanwege wettelijke regelgeving (AVG) worden overslag-e-mails voor Europa nooit automatisch verzonden. De beheerder moet ze handmatig opstellen, controleren en verzenden.',
    emailTemplateEmployee: 'E-mailsjabloon — Europa-medewerker:',
    reviewBeforeSending: 'Controleer en pas aan voor elke verzending.',
    generalNotificationsTitle: 'Algemene meldingen',
    notifMessageLabel: 'Meldingsbericht:',
    notifMessagePlaceholder: 'Schrijf het bericht dat je naar medewerkers wilt sturen...',
    notifAudienceLabel: 'Doelgroep:',
    notifAudienceGlobal: 'Globaal (excl. Europa)',
    sendNotification: 'Melding verzenden',
    availableVarsGeneral: 'Beschikbare variabelen: {nombre}, {ou}, {fecha}',
    saveChanges: 'Wijzigingen opslaan',
    saveTemplates: 'Sjablonen opslaan',
    sidebarExpand: 'Menu uitklappen',
    sidebarCollapse: 'Menu inklappen',
    analyticsComingSoon: 'Analysedashboard — in ontwikkeling. Zie de directieweergave voor volledige details.',
    colType: 'Type',
    tplCategory: 'Categorie',
    tplQuestions: 'vragen',
    tplUse: 'Gebruiken',
    tplDeleteTitle: 'Sjabloon verwijderen',
    tplDeleteDesc: '"{{name}}" verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    tipDeleteTitle: 'Tip verwijderen',
    tipDeleteDesc: '"{{name}}" verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    tipEditTitle: 'Tip bewerken',
    tipAddTitle: 'Tip toevoegen',
    tipFormFundamental: 'Fundament',
    tipFormSelectFundamental: 'Selecteer een fundament…',
    tipFormDailyHabit: 'Gekoppelde Daily Habit',
    tipFormSelectDailyHabit: 'Selecteer een Daily Habit…',
    tipFormOperator: 'Operator',
    tipFormThreshold: 'Drempel %',
    tipFormMax: 'Max %',
    tipFormType: 'Tiptype',
    tipFormName: 'Tipnaam',
    tipFormNamePlaceholder: 'Bijv. Uitzonderlijk leervermogen',
    tipFormText: 'Tiptekst',
    tipFormTextPlaceholder: 'Bericht dat de medewerker zal zien…',
    tipFormActivationRule: 'Resultaatvoorwaarde',
    tipFormActive: 'Actief',
    tipFormPreview: 'Voorbeeld',
    tipRangeMin: 'Minimumgrens',
    tipRangeMax: 'Maximumgrens',
    tipHintCondition: 'Gemiddelde score van het fundament (0–100). Bijv. 0 tot 40 activeert de tip bij lage resultaten.',
    tipHintBehavior: 'Specifiek gedrag waarop deze tip van toepassing is.',
    tipFieldObserved: 'Waargenomen tekst',
    tipTagGreen: 'lichtgroen vak',
    tipTagDark: 'donker vak',
    tipTagBlue: 'Volgend niveau-vak',
    tipHintObserved: "Wat collega's het meest opmerken. Wordt cursief weergegeven in het prestatiepaneel.",
    tipFieldGrowthSuggestion: 'Groeisuggestie',
    tipHintGrowthSuggestion: 'Uitvoerbare suggestie die naast de erkenning wordt getoond.',
    tipFieldLevelName: 'Niveaunaam',
    tipLevelNamePlaceholder: 'Bijv. Benodigde impuls, In opbouw…',
    tipCrecerPairedPlaceholder: 'Bijv. Noem de klant: Vraag bij je volgende beslissing…',
    tipTranslations: 'Vertalingen',
    tipAddLang: '+ Toevoegen:',
    tipPreviewContext: 'Zo verschijnt het op het dashboard van de medewerker:',
    tipSave: 'Tip opslaan',
    tipSaveError: 'Vul de volgende velden in om op te slaan:',
    colContent: 'Inhoud',
    colActive: 'Actief',
    opGte: 'groter dan of gelijk aan',
    opLte: 'kleiner dan of gelijk aan',
    opGt: 'groter dan',
    opLt: 'kleiner dan',
    opBetween: 'Tussen (bereik)',
    actionEditTitle: 'Actie bewerken',
    actionNewTitle: 'Nieuwe actie',
    actionFormTitle: 'Actietitel',
    actionFormTitlePlaceholder: 'Bijv. Stel een concrete actie voor',
    actionFormDescription: 'Volledige beschrijving',
    actionFormDescPlaceholder: 'Beschrijving van de actie…',
    actionActivationRule: 'Activeringsregel',
    actionActivationRuleHint: 'Gemiddelde score van het fundament (1–4). Bepaalt het bereik dat deze actie activeert.',
    actionRuleMin: 'Minimumdrempel',
    actionRuleMax: 'Maximumdrempel',
    actionRangeLabel: 'Bereik',
    actionNextLevelText: '"Volgend niveau"-tekst',
    actionNextLevelHint: 'Wordt weergegeven in het blauwe vak op de kaart.',
    actionNextLevelPlaceholder: 'Bijv. Om het volgende niveau te bereiken, focus op…',
    actionPreview: 'Voorbeeld',
    actionPreviewEmpty: 'Vul het formulier in om het voorbeeld te zien',
    actionTranslations: 'Vertalingen',
    actionTransComplete: 'Vertaling compleet',
    actionTransMissing: 'Vertaling onvolledig',
    actionPreviewContext: 'Zo verschijnt het op het dashboard van de medewerker:',
    actionFormDescHint: 'Wordt getoond wanneer de actie wordt geopend.',
    actionSave: 'Actie opslaan',
    actionSaveError: 'Vul de volgende velden in om op te slaan:',
    actionDeleteTitle: 'Actie verwijderen',
    actionDeleteDesc: '"{{name}}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
    fundEditTitle: 'Fundament bewerken',
    fundNewTitle: 'Nieuw fundament',
    fundFormFullName: 'Volledige naam',
    fundFormFullNamePlaceholder: 'Bijv. Mindset & Behavior - Learner',
    fundFormShortName: 'Korte naam',
    fundFormShortNamePlaceholder: 'Bijv. Learner',
    fundFormDescription: 'Beschrijving',
    fundFormDescriptionPlaceholder: 'Korte beschrijving van dit fundament...',
    fundFormIcon: 'Pictogram',
    fundFormColor: 'Kleur',
    fundFormUrl: 'Referentie-URL',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Taal',
    fundFormAllLangsRequired: 'Vul de volledige naam, korte naam en beschrijving in alle 7 talen in om op te slaan.',
    behEditTitle: 'Daily Habit bewerken',
    behNewTitle: 'Nieuwe Daily Habit',
    behFormName: 'Naam Daily Habit',
    behFormNamePlaceholder: 'Bijv. Humility & Openness',
    behFormAllLangsRequired: 'Vul de naam in alle 7 talen in om op te slaan.',
    behFormFundamental: 'Gekoppeld fundament',
    behFormIntro: 'Intro / beoordelingscontext',
    behFormIntroPlaceholder: 'Bijv. Tijdens deze vergadering heeft deze persoon…',
    behFormRoles: 'Toepasselijke rollen',
    behFormRolesHint: 'Voor wie geldt deze Daily Habit?',
    fundDeleteTitle: 'Fundament verwijderen',
    fundDeleteDesc: '"{{name}}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
    behDeleteTitle: 'Daily Habit verwijderen',
    behDeleteDesc: '"{{name}}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
    imageUploadSelect: 'Afbeelding uploaden',
    imageUploadChange: 'Afbeelding wijzigen',
    imageUploadInvalidFormat: 'Formaat niet ondersteund. Gebruik PNG, JPG, WEBP of SVG.',
    imageUploadTooLarge: 'Het bestand overschrijdt de maximaal toegestane grootte (2 MB).',
    fundFormImage: 'Afbeelding',
    attNewTitle: 'Nieuwe Houding en Gedrag',
    attEditTitle: 'Houding en Gedrag bewerken',
    attFormName: 'Naam van Houding en Gedrag',
    attFormNamePlaceholder: 'Bijv. Actieve samenwerking',
    attFormDescription: 'Beschrijving van Houding en Gedrag',
    attFormDescriptionPlaceholder: 'Korte beschrijving van deze houding en dit gedrag...',
    attFormAllLangsRequired: 'Vul de naam in alle 7 talen in om op te slaan.',
    attFormImage: 'Afbeelding',
    attDeleteTitle: 'Houding en Gedrag verwijderen',
    attDeleteDesc: '"{{name}}" verwijderen? De bijbehorende Daily Habits worden ook gedeactiveerd.',
    catalogAttitudesLabel: 'houdingen en gedrag',
    catalogSelectAttitude: 'Selecteer een Houding en Gedrag uit de lijst',
    catalogBackToFundamentals: 'Terug naar Fundamentals',
    catalogBackToAttitudes: 'Terug naar Houdingen en Gedrag',
    catalogGroupWithAttitudes: 'Groeperen onder Houdingen en Gedrag',
    catalogNoFundamentals: 'Geen fundamenten',
    madurezEditTitle: 'Niveaus van culturele volwassenheid bewerken',
    madurezFrameworkTitle: 'Culturele volwassenheid — Niveaukader',
    nivelesAdopcionTitle: 'Adoptiestadia van een Daily Habit — Niveaukader',
    nivelesAdopcionEditTitle: 'Adoptiestadia van een Daily Habit bewerken',
    madurezLabelPlaceholder: 'Label',
    audienceGlobal: 'Globaal (excl. Europa)',
    audienceMexico: 'Mexico',
    audienceLATAM: 'LATAM',
    audienceUSA: 'VS',
    audienceFOSE: 'FOSE',
    rn000Title: 'App per OE uitschakelen',
    rn000Subtitle: "Schakelt Sigma Pulse volledig uit voor een of meer organisatie-eenheden. Medewerkers in die OE's ontvangen geen enquêtes of meldingen meer.",
    rn000Warning: 'Wanneer een OE wordt uitgeschakeld, stoppen alle medewerkers daarvan onmiddellijk met het ontvangen van enquêtes. Historische gegevens blijven bewaard.',
    rn003Title: 'Werktijden per OE',
    rn003Subtitle: 'Uren waarin enquêtes worden toegepast (lokale tijd)',
    rn003GlobalDefault: 'Globale standaarduren',
    rn003GlobalNote: "Van toepassing op alle OE's zonder aangepaste uren.",
    rn003TimeConnector: 'tot',
    ouActive: 'Actief',
    ouDisabled: 'Uitgeschakeld',
    rn002KwLabel: 'Alleen uitsluiten als de naam bevat:',
    rn002KwHint: '(leeg = alle terugkerende)',
    rn002KwPlaceholder: 'Trefwoord toevoegen...',
    usersAdminTitle: 'Beheerdersbeheer',
    addAdmin: 'Beheerder toevoegen',
    editAdmin: 'Beheerder bewerken',
    newAdmin: 'Nieuwe beheerder',
    adminEmail: 'E-mailadres',
    adminEmailInvalid: 'Voer een geldig e-mailadres in (bijv. naam@domein.com)',
    adminRole: 'Rol',
    adminRolePlaceholder: 'Selecteer een rol...',
    adminOU: 'Operationele eenheid (OE)',
    adminOUPlaceholder: 'Selecteer een OE...',
    adminOUAll: 'Alle (volledige OE-toegang)',
    adminBU: 'Business unit (BU) — optioneel',
    adminBUPlaceholder: 'Volledige OE (geen beperking)',
    adminBUHint: 'Als er geen BU is geselecteerd, beheert de beheerder de volledige OE.',
    colUser: 'Gebruiker',
    colAlcance: 'Bereik',
    colPermisos: 'Rechten',
    colEstado: 'Status',
    permGlobalTitle: 'OE/BU-beheerders kunnen enquêtes maken',
    permGlobalDesc: 'Indien actief kunnen alle OE/BU-beheerders enquêtes maken en versturen (onder voorbehoud van goedkeuring door de centrale beheerder).',
    permEnabled: 'Ingeschakeld',
    permDisabled: 'Uitgeschakeld',
    permCreateSurveys: 'Enquêtes maken',
    permViewAnalytics: 'Analyse bekijken',
    permManageUsers: 'Gebruikers beheren',
    permApproveSurveys: 'Enquêtes goedkeuren',
    userDeleteTitle: 'Beheerder verwijderen',
    userDeleteDesc: '"{{name}}" verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    noUsersFound: 'Geen resultaten gevonden',
    adminCount: 'beheerders',
    messageForManager: 'Bericht voor de leidinggevende:',
    emailTemplateManager: 'E-mailsjabloon — Europa-leidinggevende:',
    notifOUPersonalization: 'Personalisatie per OE',
    addOUPersonalization: 'Personalisatie toevoegen',
    europaNoAutoSend: 'Deze e-mails worden niet automatisch verzonden. Ze moeten handmatig worden verzonden en afgestemd met de privacyfunctionaris van Europa.',
    europaActivateTitle: 'Europa-meldingen activeren?',
    europaActivateDesc: 'Meldingen over overslagen voor Europa zijn onderworpen aan strikte AVG-regelgeving. Door dit onderdeel te activeren bevestig je dat je toestemming hebt van de privacyfunctionaris van de OE Europa en dat e-mails handmatig worden verzonden na voorafgaande controle.',
    europaActivateConfirm: 'Ja, verantwoord activeren',
    includeEuropa: 'Europa (BU) opnemen',
    includeEuropaHint: 'vereist AVG-controle voorafgaand aan verzending',
    europaSectionDisabled: 'Onderdeel uitgeschakeld — schakel de schakelaar in om te configureren',
    ouPersonalizedSingular: 'gepersonaliseerde OE',
    ouPersonalizedPlural: "gepersonaliseerde OE's",
    notifCustomUserMsgPlaceholder: 'Aangepast bericht voor de gebruiker…',
    notifCustomMgrMsgPlaceholder: 'Aangepast bericht voor de leidinggevende…',
    kwRemove: 'Verwijderen',
    kwAdd: 'Toevoegen',
    permissions: 'Rechten',
    rules: 'Bedrijfsregels',
    catalog: 'Catalogus',
    createUser: 'Gebruiker maken',
    editUser: 'Gebruiker bewerken',
    deleteUser: 'Gebruiker verwijderen',
    roles: 'Rol',
    organizationalUnit: 'Organisatie-eenheid',
    minDuration: 'Min. duur (min)',
    maxDuration: 'Max. duur (min)',
    minParticipants: 'Min. deelnemers',
    maxPerDay: 'Max. beoordelingen per dag',
    maxPerWeek: 'Max. beoordelingen per week',
    omissionThreshold: 'Overslagdrempel',
    columns: 'Kolommen',
    colPickerTitle: 'Zichtbare kolommen',
    colPickerReset: 'Reset',
    pagerRowsPerPage: 'Rijen per pagina',
    pagerOf: 'van',
    confirmMoveToTrash: 'Naar prullenbak verplaatsen?',
    confirmMoveToTrashMsg: 'De enquête wordt naar de prullenbak verplaatst en na 30 dagen definitief verwijderd. Je kunt deze vóór die termijn herstellen.',
    confirmMoveBtn: 'Naar prullenbak verplaatsen',
    confirmDeleteForeverTitle: 'Definitief verwijderen?',
    confirmDeleteForeverMsg: 'Deze actie is onomkeerbaar. De enquête en alle bijbehorende gegevens worden voor altijd verwijderd.',
    confirmDeleteForeverBtn: 'Definitief verwijderen',
    trashTitle: 'Prullenbak enquêtes',
    trashSubtitle: 'Enquêtes worden na 30 dagen definitief verwijderd',
    trashEmpty: 'De prullenbak is leeg',
    trashRestore: 'Herstellen',
    trashDaysLeft: 'dagen resterend',
    colSurvey: 'Enquête',
    trashResponses: 'antw.',
    trashTimeLeft: 'Resterende tijd',
    trashDeletedBy: 'Verwijderd door',
    trashDeletedAt: 'Verwijderdatum',
    trashDays: 'dagen',
    trashExpiresTODAY: 'Verloopt vandaag',
    filterAll: 'Alle',
    filterSearchName: 'Naam zoeken…',
    filterSearchCreator: 'Maker zoeken…',
    filterFrom: 'Van',
    filterTo: 'Tot',
    filterClearDates: 'Datums wissen',
    pauseSurvey: 'Pauzeren',
    activateSurvey: 'Activeren',
    builderNewTitle: 'Nieuwe enquête',
    builderEditTitle: 'Enquête bewerken',
    builderNewTemplateTitle: 'Nieuw sjabloon',
    builderEditTemplateTitle: 'Sjabloon bewerken',
    builderBackToSurveys: 'Terug naar enquêtes',
    builderSaveDraft: 'Concept opslaan',
    builderPublish: 'Enquête publiceren',
    builderStep1: 'Basisinformatie',
    builderStep2: 'Doelgroep en frequentie',
    builderStep3: 'Vragen',
    builderStep4: 'Controle',
    builderPreview: 'Voorbeeld',
    builderName: 'Naam van de enquête',
    builderNamePlaceholder: 'Bijv.: Post-vergaderbeoordeling Q2',
    builderDescription: 'Beschrijving',
    builderDescriptionPlaceholder: 'Beschrijf het doel van deze enquête…',
    builderApproach: 'Aanpak',
    builderApproachIndividual: 'Individueel',
    builderApproachCollective: 'Collectief',
    builderAnonymous: 'Anonieme beoordeling',
    builderAnonymousSub: 'Beoordeelden weten niet wie hen heeft beoordeeld',
    dayMon: 'Maandag', dayTue: 'Dinsdag', dayWed: 'Woensdag', dayThu: 'Donderdag',
    dayFri: 'Vrijdag', daySat: 'Zaterdag', daySun: 'Zondag',
    dayMonShort: 'Ma', dayTueShort: 'Di', dayWedShort: 'Wo', dayThuShort: 'Do',
    dayFriShort: 'Vr', daySatShort: 'Za', daySunShort: 'Zo',
    dayLetterMon: 'M', dayLetterTue: 'D', dayLetterWed: 'W', dayLetterThu: 'D',
    dayLetterFri: 'V', dayLetterSat: 'Z', dayLetterSun: 'Z',
    activeDaysAll: 'De enquête is de hele week actief',
    activeDaysPrefix: 'De enquête is actief op:',
    activeDaysNone: 'Geen dagen geselecteerd',
    workdays: 'Werkdagen',
    builderExitTitle: 'De editor verlaten?',
    builderExitDesc: 'Niet-opgeslagen wijzigingen gaan verloren als je nu vertrekt.',
    builderExitCancel: 'Verder bewerken',
    builderExitConfirm: 'Ja, verlaten',
    builderValidationTitle: 'Verplichte velden',
    builderValidationDesc: 'Vul de volgende velden in voordat je verdergaat:',
    builderValidationClose: 'Begrepen',
    builderValidationName: 'Interne identificatie',
    builderValidationSurveyType: 'Enquêtetype',
    builderValidationStartDate: 'Startdatum',
    builderValidationEndDate: 'Einddatum',
    builderValidationDateRange: 'De einddatum kan niet eerder zijn dan de startdatum',
    builderValidationActiveDays: 'Minstens één actieve dag',
    builderValidationMeetingId: 'Voer de vergader-ID in',
    builderValidationPeople: 'Selecteer minstens één persoon',
    builderValidationOU: 'Selecteer minstens één OE',
    builderValidationNoQuestions: 'Je moet minstens één vraag toevoegen om verder te gaan. Enquêtes kunnen niet worden aangemaakt zonder vragen.',
    builderValidationMinParticipants: 'Het minimumaantal deelnemers moet minstens 1 zijn',
    builderValidationMaxParticipants: 'Het maximumaantal deelnemers moet minstens 1 zijn',
    builderValidationParticipantsRange: 'Het minimumaantal deelnemers mag niet groter zijn dan het maximum',
    builderValidationTranslations: 'Onvolledige vertalingen',
    // Builder new keys
    builderCloseEditor: 'Editor sluiten',
    builderPrevious: 'Vorige',
    builderNext: 'Volgende',
    builderSaveTemplate: 'Opslaan als sjabloon',
    builderInternalId: 'Interne identificatie',
    builderInternalIdHint: 'Alleen zichtbaar voor beheerders — medewerkers zien deze naam niet tijdens het invullen',
    builderSurveyTypeStar: 'Enquêtetype',
    builderTypeGeneral: 'Algemeen',
    builderTypeGeneralDesc: 'Gestuurd door bedrijfsregels. Wordt automatisch geactiveerd na vergaderingen.',
    builderTypePersonalized: 'Gepersonaliseerd',
    builderTypePersonalizedDesc: 'Gekoppeld aan een specifieke Teams-sessie via de vergader-ID.',
    builderPeriod: 'Enquêteperiode',
    builderStartLabel: 'Start',
    builderEndLabel: 'Einde',
    builderPeriodHint: 'De enquête wordt geactiveerd op de startdatum en automatisch gedeactiveerd bij afloop',
    builderActiveDaysLabel: 'Actieve dagen',
    builderCustomTag: 'Aangepast',
    builderAudienceSectionTitle: 'Doelgroep',
    builderWhoApplies: 'Voor wie geldt deze enquête?',
    builderSelectOneOrMoreOUs: "Selecteer een of meer OE's",
    builderGlobal: 'Globaal',
    builderGlobalDesc: "Alle OE's en BU's",
    builderExcludesEurope: 'exclusief Europa',
    builderGlobalAdminOUAccess: "Globale beheerder — je hebt toegang tot alle OE's in het systeem.",
    builderLegalRegulation: 'Wettelijke regelgeving — altijd een apart veld',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'AVG — Wettelijke regelgeving',
    builderEuropeExcludedNote: 'Europa wordt vanwege wettelijke naleving nooit opgenomen in globale of multi-OE-campagnes.',
    builderEuropaAuthNote: 'Vergeet niet toestemming te vragen aan de OE Europa voordat je enquêtes naar deze regio verstuurt.',
    builderAudienceCustomTitle: 'Ontvangers',
    builderAudienceCustomSubtitle: 'Bepaal wie deze gepersonaliseerde enquête zal ontvangen.',
    builderRecipientsLabel: 'Ontvangers',
    builderByMeetingId: 'Op vergader-ID',
    builderByPeople: 'Specifieke personen',
    builderByOU: 'Op organigram (OE)',
    audienceTypeMeeting: 'Vergadering',
    audienceTypePeople: 'Personen',
    audienceTypeOU: 'OE',
    builderMeetingIdHint: 'Wordt toegepast op alle deelnemers van die Teams-sessie',
    builderSelectPeople: 'Selecteer personen uit de lijst',
    builderAllOUs: "Alle OE's",
    builderAllAvailableAdded: 'Alle beschikbare personen zijn al toegevoegd',
    builderSearchPeoplePlaceholder: 'Zoek een persoon op naam…',
    builderLoadingPeople: 'Personen laden…',
    builderErrorLoadingPeople: 'De personenlijst kon niet worden geladen. Probeer het opnieuw.',
    builderPersonSelected: 'persoon geselecteerd',
    builderPeopleSelected: 'personen geselecteerd',
    builderSelectOU: 'Selecteer een OE...',
    builderSelectOUForTeam: 'Selecteer een OE om de leden ervan te bekijken',
    builderQuestionsTitle: 'Vragen',
    builderEuropaQuestionsNote: 'Europa-modus: open enquête, niet gekoppeld aan Fundamenten. Alleen vragen over de vergadering.',
    builderQuestionsApplyToAll: 'Elke vraag geldt voor elke deelnemer aan de vergadering.',
    builderFilterAll: 'Alle',
    builderNoQuestions: 'Nog geen vragen',
    builderNoQuestionsHint: 'Klik op "+ Vraag toevoegen" om te beginnen',
    builderNoQuestionsOfType: 'Geen vragen van dit type',
    builderAddQuestion: '+ Vraag toevoegen',
    builderQuestionLabel: 'Vraag',
    builderDeleteQuestion: 'Verwijderen',
    builderApproachLabel: 'Aanpak',
    builderIndividualSub: 'Beoordeelt elke deelnemer',
    builderCollectiveSub: 'Voor de sessie als geheel',
    builderPresentationMode: 'Weergavemodus',
    builderMatrix: 'Algemene matrix',
    builderMatrixSub: 'Vraag over de vergadering of algemeen onderwerp',
    builderIndividualCard: 'Individueel',
    builderIndividualCardSub: 'Eén kaart per persoon',
    builderTypeLabel: 'Type',
    builderFundamentalLabel: 'Fundament',
    builderSelectFundamental: 'Selecteer een Fundament...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Selecteer een Daily Habit...',
    builderQuestionText: 'Vraagtekst',
    builderQuestionTextPlaceholder: 'Schrijf de vraag hier',
    builderIconLabel: 'Pictogram',
    builderOptional: '(optioneel)',
    builderChangeIcon: 'Wijzigen',
    builderSelectIconBtn: 'Pictogram selecteren',
    builderOptionsLabel: 'Opties (max. 4 + "Niet waarneembaar")',
    builderNoObservable: 'Niet waarneembaar',
    builderRemoveNoObs: '"Niet waarneembaar" verwijderen',
    builderAddNoObs: '"Niet waarneembaar" toevoegen',
    builderAddOption: 'Optie toevoegen',
    builderMaxOptions: 'Maximum van 4 opties bereikt',
    builderNPSInfo: 'NPS: schaal van 0 tot 10. Open vraag, niet toegewezen aan deelnemers.',
    builderOpenInfo: 'Open ruimte voor de beoordelaar om het antwoord te schrijven.',
    builderCampaignWeight: 'Campagnegewicht',
    builderAdminGlobalOnly: 'Alleen globale beheerder',
    builderCampaignWeightSub: 'Hoger gewicht = hogere prioriteit wanneer meerdere enquêtes actief zijn. Alleen de globale beheerder kan dit wijzigen.',
    builderWeightBase: 'Basisgewicht (1–10)',
    builderWeightVeryLow: 'Zeer laag',
    builderWeightLow: 'Laag',
    builderWeightMedium: 'Gemiddeld',
    builderWeightHigh: 'Hoog',
    builderWeightVeryHigh: 'Zeer hoog',
    builderBoostUrgent: 'Dringende boost',
    builderBoostUrgentSub: 'Verhoogt deze enquête tijdelijk boven alle andere',
    builderBoostDays: 'dagen',
    builderBoostActiveDays: 'dag',
    builderBoostActiveMsg: 'Boost actief — deze enquête heeft maximale prioriteit gedurende',
    builderNoBoostMsg: 'Geen actieve boost — prioriteit op basis van basisgewicht',
    builderParticipantsTitle: 'Te beoordelen deelnemers',
    builderParticipantsSub: 'Bepaal hoeveel mensen per enquête worden beoordeeld. Minimum voor anonimiteit en maximum om overbelasting te voorkomen.',
    builderMinParticipantsLabel: 'Minimumaantal deelnemers',
    builderMinParticipantsHint: 'Min. om anonimiteit te waarborgen',
    builderMaxParticipantsLabel: 'Maximumaantal deelnemers',
    builderMaxParticipantsHint: 'Max. te beoordelen personen per enquête',
    builderPrivacyTitle: 'Privacy en anonimiteit',
    builderPrivacySub: 'Bepaal of feedback wordt gekoppeld aan de identiteit van de respondent.',
    builderEnableAnonymity: 'Anonimiteit inschakelen',
    builderAnonymityDesc: 'Feedback bevat geen gebruikersnaam — alleen het antwoord en tijdstip',
    builderTranslationsTitle: 'Vertalingen',
    builderTranslationsEuropeSub: 'Doelgroep Europa — alle 6 talen zijn verplicht. Gebruik de schakelaar om een taal in of uit te schakelen.',
    builderTranslationsSub: 'Een Engelse vertaling is minimaal verplicht. Gebruik de schakelaar om extra talen in te schakelen.',
    builderAutoTranslateNote: 'Vertalingen worden automatisch gegenereerd met Azure Translator. Controleer en pas elk veld indien nodig aan.',
    builderLangNotApplicable: 'Niet van toepassing',
    builderLangComplete: 'Voltooid',
    builderLangPending: 'In behandeling',
    builderLangRequired: 'Verplicht',
    builderAutoTranslateBtn: 'Automatisch vertalen',
    builderLangApplies: 'Van toepassing',
    builderLangDoesNotApply: 'Niet van toepassing',
    builderTrlName: 'Naam:',
    builderTrlDesc: 'Beschrijving:',
    builderTrlEmpty: 'leeg',
    builderLangDisabled: 'Deze taal is uitgeschakeld voor deze enquête.',
    builderReviewTitle: 'Controleren en publiceren',
    builderReviewTemplateTitle: 'Sjabloon controleren',
    builderEuropaPublishNote: 'Europa-modus: onafhankelijke campagne vanwege de AVG. Vergeet niet toestemming te vragen aan de OE Europa.',
    builderPublishIdLabel: 'Identificatie',
    builderPublishInternal: '(intern)',
    builderPublishTypeLabel: 'Type',
    builderPublishAudienceLabel: 'Doelgroep',
    builderPublishQuestionsLabel: 'Vragen',
    builderPublishActiveDaysLabel: 'Actieve dagen',
    builderPublishExpirationLabel: 'Vervaldatum',
    builderPublishAnonymityLabel: 'Anonimiteit',
    builderPublishAnonymousVal: 'Anoniem',
    builderPublishNominalVal: 'Nominaal',
    builderCompleteBeforePublish: 'Aanvullen vóór publicatie:',
    builderCompleteBeforeSave: 'Aanvullen vóór opslaan:',
    builderReadyToPublish: 'Alles klaar. Klik op Enquête publiceren om deze te activeren.',
    builderReadyToSaveTemplate: 'Alles klaar. Klik op Sjabloon opslaan om het op te slaan.',
    builderIconCatalogTitle: 'Pictogrammencatalogus',
    builderSystemIcons: 'Systeempictogrammen',
    builderNoIcon: 'Geen pictogram',
    builderMyCatalog: 'Mijn catalogus',
    builderDeleteFromCatalog: 'Verwijderen uit catalogus',
    builderCatalogEmpty: 'Je catalogus is leeg — upload een pictogram en sla het hier op',
    builderUploadIcon: 'Nieuw pictogram uploaden',
    builderIconNamePlaceholder: 'Naam van het pictogram (bijv. Innovatie)',
    builderSelectFile: 'Bestand selecteren',
    builderInvalidFormat: 'Ongeldig formaat. Gebruik SVG of PNG met een transparante achtergrond.',
    builderFileTooLarge: 'Bestand te groot. Maximaal 200 KB.',
    builderCustomIcon: 'Aangepast pictogram',
    builderSaveForReuse: 'Opslaan in catalogus voor hergebruik',
    builderUseIcon: 'Pictogram gebruiken',
    builderIconHelp: 'SVG of PNG, transparante achtergrond, 512×512 px aanbevolen, max. 200 KB',
    builderPreviewCompleteStep1: 'Vul de gegevens van stap 1 in om het voorbeeld te zien',
    builderPreviewClickToEdit: 'Klik op een willekeurige tekst om te bewerken',
    builderPreviewNoQuestions: 'Vragen verschijnen hier in stap 3',
    builderPreviewGeneral: 'Algemeen',
    builderPreviewPersonalized: 'Gepersonaliseerd',
    builderPreviewPulsoEspecifica: 'Specifieke Pulse',
    builderPreviewChangeIcon: 'Pictogram wijzigen',
    builderPreviewIndividual: 'Individueel',
    builderPreviewCollective: 'Collectief',
    builderPreviewModeIndividual: 'Individueel',
    builderPreviewModeMatrix: 'Algemene matrix',
    builderPreviewMissingTranslation: '(geen vertaling)',
    builderPreviewWriteAnswer: 'Schrijf hier je antwoord...',
    builderPreviewNoObs: 'Niet waarneembaar',
    builderPreviewNA: 'N.v.t.',
    // Step nav labels
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Doelgroep',
    builderNavPreguntas: 'Vragen',
    builderNavConfig: 'Instellingen',
    builderNavPublicar: 'Publiceren',
    builderNavGuardar: 'Opslaan',
    // Step 1 title
    builderInfoTitle: 'Basisinformatie',
    // Audience step
    builderSelectAll: 'Alles selecteren',
    // Language names
    langEn: 'Engels',
    langDe: 'Duits',
    langPt: 'Portugees',
    langFr: 'Frans',
    langNl: 'Nederlands',
    langRo: 'Roemeens',
    // Translation placeholders
    builderTrlPlaceholderIn: 'in',
    builderTrlPlaceholderOpt: 'Optie',
    builderTrlNoText: 'Nog geen tekst',
    // New keys added during refactor
    builderLinkedTo: 'Gekoppeld aan',
    builderSelectedIcon: 'Geselecteerd',
    builderHidePreview: 'Voorbeeld verbergen',
    builderShowPreview: 'Voorbeeld tonen',
    builderPreviewMorePersons: 'meer personen',
    builderPreviewOption1: 'Optie 1',
    builderPreviewOption2: 'Optie 2',
    builderPreviewViewIn: 'Bekijken in:',
    builderFromOU: 'van',
    builderWillReceiveSurvey: 'zal deze enquête ontvangen',
    builderPersonsCount: 'personen',
    builderPersonsPlural: 'personen',
    builderPersonSingular: 'persoon',
    builderInternalIdPlaceholder: 'Bijv. Fundamenten Q1 2026',
    builderMeetingIdPlaceholder: 'Bijv. 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Optie',
    builderRemovePerson: 'Verwijderen',
    builderSaveTemplateMock: 'Opgeslagen als sjabloon ✓',
    builderPublishGlobalLabel: 'Globaal (excl. Europa)',
    builderTypeRating: 'Beoordeling (1-4)',
    builderTypeMultiple: 'Meerkeuze',
    builderTypeOpen: 'Open vraag',
    builderTypeBehaviors: 'Gedragingen',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Systeem',
    // Monitor tab
    monitorTab: 'Monitoring',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'AD-synchronisatiejobs',
    subtitle: 'Status, geschiedenis en handmatige uitvoering van de jobs die OU\'s en gebruikers vanuit Azure AD synchroniseren.',
    ouCatalogSync: 'OU-synchronisatie',
    userCatalogSync: 'Gebruikerssynchronisatie',
    statusNeverRun: 'Nooit uitgevoerd',
    statusRunning: 'Bezig…',
    statusSuccess: 'Succes',
    statusSkipped: 'Overgeslagen',
    statusFailed: 'Fout',
    lastRun: 'Laatste uitvoering',
    duration: 'Duur',
    triggerScheduled: 'Automatisch',
    triggerManual: 'Handmatig',
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    unchanged: 'Ongewijzigd',
    skipReason: 'Reden',
    errorMessage: 'Fout',
    nextScheduled: 'Volgende automatische uitvoering',
    nextScheduledUnknown: 'Wordt berekend na de eerste uitvoering',
    runNow: 'Nu uitvoeren',
    runningDisabled: 'Wordt al uitgevoerd',
    viewHistory: 'Geschiedenis bekijken',
    hideHistory: 'Geschiedenis verbergen',
    historyEmpty: 'Nog geen uitvoeringen geregistreerd.',
    historyLoading: 'Geschiedenis laden…',
    historyError: 'Kon geschiedenis niet laden.',
    colDate: 'Datum',
    colTrigger: 'Trigger',
    colStatus: 'Status',
    colDuration: 'Duur',
    colDetail: 'Detail',
    triggerError: 'Kon de job niet uitvoeren.',
    triggerConflict: 'De job wordt al uitgevoerd — wacht tot deze klaar is.',
  },
  monitor: {
    title: 'Pipelinemonitor',
    subtitle: 'Geschiktheidsaudit per vergadering: geëvalueerde regels, uitgesloten deelnemers en toegepaste steekproef.',
    refresh: 'Vernieuwen',
    loading: 'Gebeurtenissen laden…',
    lastFetch: 'Bijgewerkt',
    timeout: 'Time-out (10s) — MeetingService heeft niet gereageerd.',
    unknownError: 'Onbekende fout',
    empty: 'Geen pipelinegebeurtenissen. Verwerk of simuleer een vergadering om records te zien.',
    eligible: 'In aanmerking',
    ineligible: 'Niet in aanmerking',
    excluded: 'Uitgesloten',
    sampled: 'Gesteekproefd',
    samplingApplied: 'Steekproef toegepast',
    noParticipants: 'Geen deelnemersdetail.',
    statTotal: 'Verwerkte vergaderingen',
    statEligible: 'Vergaderingen in aanmerking',
    statAvgSampled: 'Gem. gesteekproefd',
    statAvgSampledSub: 'per vergadering in aanmerking',
    statSampling: 'Steekproef toegepast',
    statSamplingSub: 'vergaderingen met actieve maxPax',
    colMeetingId: 'Vergader-ID',
    colDate: 'Datum',
    colDuration: 'Duur',
    colEvaluated: 'Beoordeeld',
    colEligible: 'In aanmerking',
    colSampled: 'Gesteekproefd',
    colMaxPax: 'Steekproef',
    colResult: 'Resultaat',
    colUserId: 'Gebruiker',
    colOu: 'OE',
    colTimezone: 'Tijdzone',
    colToday: 'Vandaag',
    colWeek: 'Week',
    colInterval: 'Interval',
    colStatus: 'Status',
    colReason: 'Reden',
    colSample: 'Enquête',
    instancesTitle: 'Toegewezen enquêtes',
    instancesBtnTitle: 'Enquêtes voor deze deelnemer bekijken',
    instancesLoading: 'Enquêtes laden…',
    instancesEmpty: 'Geen enquête-instanties gevonden voor deze deelnemer in deze vergadering.',
    instancesSurvey: 'Enquête',
    instancesStatus: 'Status',
    instancesExpires: 'Verloopt',
    instancesDownload: 'JSON downloaden',
    instancesClose: 'Sluiten',
    sortAsc: 'Oplopend sorteren',
    sortDesc: 'Aflopend sorteren',
    recalculate: 'Antwoorden herberekenen',
    recalculateTitle: 'Aantal antwoorden op alle enquêtes herberekenen',
    recalculateSuccess: 'Herberekening voltooid: {{count}} enquête(s) bijgewerkt.',
    recalculateError: 'Fout bij het herberekenen van antwoorden.',
    cacheTitle: 'OE-catalogcache',
    cacheLoading: 'Cache wordt gecontroleerd…',
    cacheError: 'Kon de OE-cachestatus niet ophalen.',
    cachePopulated: 'Gevuld',
    cacheNotPopulated: 'Niet gevuld',
    cacheOuCount: "OE's in cache",
    cacheLastSynced: 'Laatste synchronisatie',
    cacheNeverSynced: 'Nooit gesynchroniseerd',
  },
  system: {
    title: 'Systeemdiagnostiek',
    subtitle: 'Realtimestatus van alle backend-microservices en workers.',
    refreshAll: 'Alles vernieuwen',
    refresh: 'Vernieuwen',
    lastChecked: 'Laatst gecontroleerd',
    checking: 'Controleren…',
    never: 'Nooit',
    statusHealthy: 'Gezond',
    statusDegraded: 'Verminderd',
    statusError: 'Verbindingsfout',
    showDetails: 'Controles tonen',
    hideDetails: 'Controles verbergen',
    legendTitle: 'Statusverklaring',
    legendHealthyDesc: 'Alle interne servicecontroles reageerden correct.',
    legendDegradedDesc: 'De service reageert, maar MongoDB, Redis of Service Bus meldde een fout.',
    legendErrorDesc: 'De service kon niet worden bereikt vanaf de frontend (time-out, CORS of service uitgeschakeld).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Abonnementen',
    activeMessages: 'Actieve berichten',
    deadLetterMessages: 'Dead Letter',
    environment: 'Omgeving',
    version: 'Versie',
    workers: 'Workers',
    workersDesc: 'Status afgeleid van Service Bus-abonnementsstatistieken.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Geen abonnementsstatistieken beschikbaar.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Fout',
  },
  analytics: {
    title: 'Directiedashboard',
    subtitle: 'Sigma Pulse Analyse',
    bias: 'Vertekeningen',
    omissions: 'Overslagen',
    personal: 'Persoonlijk',
    score: 'Score',
    responses: 'Antwoorden',
    participants: 'Deelnemers',
    period: 'Periode',
    ou: 'Organisatie-eenheid',
    noData: 'Onvoldoende gegevens',
    completionRate: 'Voltooiingspercentage',
    avgByCategory: 'Gemiddelde per categorie',
    organization: 'Organisatie',
    fundamentalsRadar: 'Fundamentenradar',
    heatmapPersonFund: 'Heatmap — Score per persoon en fundament',
    moduleInDev: 'Module in ontwikkeling',
    executiveSubtitle: 'directieweergave',
    exec: {
      ouTech: 'Technologie',
      ouOps: 'Operations',
      ouSales: 'Verkoop',
    },
    tabs: {
      summary: 'Samenvatting',
      fundamentals: 'Fundamenten',
      heatmap: 'Heatmap',
      orgNetwork: 'Organisatienetwerk',
      generational: 'Generationeel',
    },
    filterBar: {
      allOrg: 'Hele organisatie',
      allBU: "Alle BU's",
      allDept: 'Alle afdelingen',
      allFund: 'Alle fundamenten',
      clearFilters: 'Filters wissen',
      dateFrom: 'Van',
      dateTo: 'Tot',
    },
    kpi: {
      evaluations: 'Beoordelingen',
      avgScore: 'Gem. score',
      responseRate: 'Responspercentage',
      avgPerDay: 'Gem. / dag',
      evaluators: 'Beoordelaars',
      scale: 'schaal 1–4',
      noObservables: 'niet waarneembaar',
      perDay: 'enquêtes per dag',
      activeParticipants: 'actieve deelnemers',
      ofTotal: 'totaal',
    },
    summary: {
      topBehaviors: 'Top Daily Habits',
      topDailyHabitsSubtitle: 'Gewoonten met de grootste culturele impact',
      oppSubtitle: 'Gewoonten met de meeste ruimte voor verbetering',
      opportunities: 'Verbeterpunten',
      omissionsByUnit: 'Overslagen per eenheid',
      omissionsSubtitle: "Overslagpercentage per OE en BU — gesorteerd van hoog naar laag · Klik op een OE om de bijbehorende BU's te zien",
      downloadExcel: 'Excel downloaden',
      omitType: 'Type',
      omitPeople: 'Personen',
      omitRate: 'Overslagpercentage',
      noOmissions: 'Geen significante overslagen',
      percentileDistribution: 'Percentielverdeling',
      percentileSubtitle: 'Percentage van de populatie in elk scorebereik',
      personsEvaluated: 'beoordeelde personen',
      excellent: 'Uitstekend',
      good: 'Goed',
      developing: 'In ontwikkeling',
      attention: 'Aandacht nodig',
      fundPositioning: 'Positionering fundamenten',
      fundPositioningDesc: 'Ranking, hoogste/laagste score en percentage niet-waarneembaar per fundament',
      highestScore: 'Hoogste score',
      lowestScore: 'Laagste score',
      mostNoObs: 'Meest niet waarneembaar',
      scoreByOU: 'Score per organisatie-eenheid',
      scoreByOUSubtitle: 'Klik op een OE om de uitsplitsing per BU en afdeling te zien',
      person: 'persoon',
      persons: 'personen',
    },
    fundamentals: {
      title: 'Score per fundament',
      subtitle: 'Vouw elk fundament uit om de daily habits en de uitsplitsing per OE te zien',
      evalLabel: 'beoord.',
      confPreliminary: 'Voorlopige gegevens',
      confBasedOn: 'Gebaseerd op {{n}} beoordelingen',
    },
    heatmap: {
      title: 'Culturele heatmap',
      subtitle: 'Tik op een rij om de sub-eenheden ervan te verkennen',
      unit: 'Eenheid',
      unitOU: 'Organisatie-eenheid',
      unitBU: 'Business unit',
      unitDept: 'Afdeling',
      unitPerson: 'Leidinggevende',
      allOrg: 'Hele organisatie',
      hint: 'Tik op een rij om het volgende niveau te verkennen →',
      person: 'persoon',
      persons: 'personen',
      legendCritical: 'Kritiek',
      legendLow: 'Laag',
      legendMedium: 'Gemiddeld',
      legendGood: 'Goed',
      legendExcellent: 'Uitstekend',
      noOu: 'Geen OU',
    },
    ona: {
      title: 'Organisatienetwerk (ONA)',
      subtitle: 'Interactieve boomstructuur van organisatie-eenheden (OE)',
      treeHint: 'Vouw elk knooppunt uit om de OE-niveaus van de organisatie te navigeren.',
      omissions: 'Overslagen',
      totalPeople: 'Personen',
      avgScore: 'Gem. score',
      totalEvals: 'Totaal aantal beoordelingen',
      collaboratorsKpi: 'Medewerkers',
      highestOmission: 'Hoogste overslag',
      omissionsRanking: 'Ranglijst overslagen',
      maturityCulture: 'Culturele volwassenheid',
      maturityLegend: 'Volwassenheidslegenda',
      maturityInitial: 'Beginnend',
      maturityGrowing: 'Groeiend',
      maturityConsolidated: 'Geconsolideerd',
      maturityRoleModel: 'Rolmodel',
      evalsLabel: 'beoordelingen',
      noEvals: 'Geen beoordelingen',
      collaboratorsLabel: 'medewerkers',
      omissionLabel: 'overslag',
      evalsShort: 'beoord.',
    },
    gen: {
      panorama: 'Overzicht',
      ranking: 'Ranglijst',
      brechas: 'Verschillen',
      avgAge: 'Gem. leeftijd',
      title: 'Generatieanalyse',
      subtitle: 'Culturele verdeling en volwassenheid per cohort · {{n}} personen in kaart gebracht',
      noRepresentation: 'Geen vertegenwoordiging',
      scoreLabel: 'Score',
      omissionLabel: 'Overslag',
      personas: 'personen',
      age: 'Leeftijd',
      all: 'Alle',
      noData: 'Geen gegevens voor dit filter',
      fundamental: 'Fundament',
      gapCol: 'Δ Verschil',
      brechaNote: 'Grootste verschil: {{fund}} · Δ {{delta}} pt tussen generaties',
      brechaSource: 'Verschil t.o.v. het algemene gemiddelde van het fundament in de organisatie',
      responseCount: '{{n}} reacties',
    },
  },
  userConfig: {
    fabTitle: 'Gebruikersprofiel configureren',
    title: 'Gebruikersprofiel (demo)',
    subtitle: 'Testmodus — simuleert gegevens die bij backend-integratie via Teams SSO beschikbaar komen',
    nombre: 'Naam',
    correo: 'E-mail',
    ou: 'OE (organisatie-eenheid)',
    do_: 'DO (divisie)',
    bu: 'BU (business unit)',
    departamento: 'Afdeling',
    puesto: 'Functietitel',
    numeronomina: 'Personeelsnummer',
    role: 'Rol',
    roleDetected: 'Gedetecteerde rol',
    roleNotFound: 'E-mail niet gevonden bij gebruikers — rol Medewerker wordt gebruikt',
    save: 'Profiel opslaan',
    namePlaceholder: 'Bijv.: Ana García',
    emailPlaceholder: 'Bijv.: agarcia@sigma.com',
    ouPlaceholder: 'Bijv.: Technologie',
    doPlaceholder: 'Bijv.: Divisie Technologie',
    buPlaceholder: 'Bijv.: Mexico',
    deptPlaceholder: 'Bijv.: Softwareontwikkeling',
    puestoPlaceholder: 'Bijv.: Senior Software Engineer',
    nominaPlaceholder: 'Bijv.: 123456',
    fechaNacimiento: 'Geboortedatum',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Er is een onverwachte fout opgetreden',
    unauthorized: 'Je hebt geen toestemming voor deze actie',
    notFound: 'Bron niet gevonden',
    network: 'Verbindingsfout. Controleer je netwerk.',
  },
};

export default nl;
